import { DatePipe } from '@angular/common';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { RoomDTO } from 'src/app/demo/model/RoomDTO';
import { StudentDTO } from 'src/app/demo/model/StudentDTO';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { OperationService } from 'src/app/demo/service/operation.service';
import { Common } from 'src/app/demo/utils/common';
import { WebStorage } from '../../../auth/storage/web.storage';
import { ITEMS_PER_PAGE } from 'src/app/demo/constants/pagination.constants';
import { AttendanceDTO } from 'src/app/demo/model/AttendanceDTO';
import { Table } from 'primeng/table';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { StaffDTO } from 'src/app/demo/model/StaffDTO';
import { Dropdown } from 'primeng/dropdown';
import { MasterLookupDTO } from 'src/app/demo/model/MasterLookupDTO';
import { TagDTO } from 'src/app/demo/model/TagDTO';
import { SignoutStudentComponent } from '../signout-student/signout-student.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { profielBackgroundColor } from 'src/app/demo/sharing/constants/profielBackgroundColor';
// function getCurrentHourAndMinuteIn24HourFormat() {
//   const now = new Date();
//   const hours = now.getHours();
//   const minutes = now.getMinutes();
//   return { hours, minutes };
// }
// const { hours, minutes } = getCurrentHourAndMinuteIn24HourFormat();
// const currentTime24hr = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
@Component({
    selector: 'app-transfer-student',
    templateUrl: './transfer-student.component.html',
    styleUrls: ['./transfer-student.component.scss'],
})
export class TransferStudentComponent {
    userData: any;
    search: any = {};
    pageContext = {
        page: 0,
        previousPage: 0,
        itemsPerPage: 25,
        totalItems: 0,
        sort: 'id,asc',
    };
    roomList: RoomDTO[] = [];
    filteredRoomList: RoomDTO[] = [];
    roomObj: RoomDTO = {};
    tagList: TagDTO[] = [];
    statusList: MasterLookupDTO[] = [];
    selectedRoomId: any;
    selectedTagId: any;
    selectedStatus: any;
    studentList: any[] = [];
    selectAllStudents: boolean = false;
    selectedStudents: any[] = [];
    selectedStudentIds: number[] = [];
    selectedStudentList: any[] = [];
    actualStudList: StudentDTO[] = [];
    studentSearchInput: any;
    selectedRoom: undefined;
    signOutTime = Common.momentTimeZoneTime(new Date());
    selectedDate: any = Common.momentTimeZoneDate(new Date());
    submitForm: boolean = false;
    items!: MenuItem[];
    activeIndex: number = 0;
    studentSignIn!: FormGroup;
    counter: number = 0;
    displayTransferDailog: boolean = false;
    selectedStudentsFromOverview: any[] = [];
    fromOverView: boolean = false;
    staffObj: any;
    roomIds: any;
    isAdminUserLogin: boolean = false;
    profileBgColor: string[] = [];
    constructor(
        private lookupService: LookupService,
        private operationService: OperationService,
        private storage: WebStorage,
        private formBuilder: FormBuilder,
        private messageService: MessageService,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private confirmationService: ConfirmationService,
    ) {
        this.roomObj = this.config.data;
        this.profileBgColor = profielBackgroundColor;
        this.activeIndex = this.config.data.activeIndex;
        this.fromOverView = this.config.data.fromOverView;
        this.selectedStudentsFromOverview = this.config.data.fromOverView
            ? this.config.data.selectedStudents
            : [];
    }

    ngOnInit(): void {
        this.userData = this.storage.getUserData();
        this.isAdminUserLogin = Common.isAdminUserLogin(this.storage);
        this.items = [
            {
                label: 'Select Students',
                command: (event: any) =>
                    this.messageService.add({
                        severity: 'info',
                        summary: 'First Step',
                        key: 'message',
                        detail: event.item.label,
                        life: 3000,
                    }),
            },
            {
                label: 'Confirm Student',
                command: (event: any) =>
                    this.messageService.add({
                        severity: 'info',
                        key: 'message',
                        summary: 'Second Step',
                        detail: event.item.label,
                        life: 3000,
                    }),
            },
        ];
        this.studentSignIn = this.formBuilder.group({
            id: ['', []],
            signInTime: ['', [Validators.required]],
            signOutTime: ['', []],
            attendedTime: ['', []],
            signInBy: ['', []],
            signOutBy: ['', []],
            note: ['', []],
            roomId: ['', [Validators.required]],
            status: ['', []],
            schoolId: ['', []],
            staffId: ['', [Validators.required]],
            studentId: ['', []],
            staffName: ['', []],
            hasSignIn: [false, []],
            date: ['', []],
            signInHR: ['', []],
            signInMIN: ['', []],
            signOutHR: [undefined, []],
            signOutMIN: [undefined, []],
        });
        this.getTagData();
        this.getMasterlookupData();
        this.lookupService
            .getStaffById(this.userData.refTableId)
            .subscribe((res: HttpResponse<StaffDTO>) => {
                let temp: StaffDTO = {};
                this.staffObj = res.body ? res.body : temp;
                this.roomIds = [];
                this.selectedRoomId = !this.isAdminUserLogin
                    ? this.staffObj.primaryRoomId
                    : undefined;

                if (this.staffObj.rooms && this.staffObj.rooms.length > 0) {
                    this.roomIds = this.staffObj.rooms
                        .filter(
                            (room: RoomDTO) =>
                                room?.id !== undefined &&
                                typeof room.id === 'number',
                        )
                        .map((room: RoomDTO) => room.id as number);
                }

                if (
                    this.staffObj.primaryRoomId &&
                    typeof this.staffObj.primaryRoomId === 'number'
                ) {
                    this.roomIds.push(this.staffObj.primaryRoomId);
                }
                // this.loadRooms(this.staffObj.primaryRoomId);
                this.getRoomData(this.staffObj.primaryRoomId);
                this.queryData();
                this.search = {};
            });
    }

    onActiveIndexChange(event: number) {
        this.activeIndex = event;
    }

    complete() {
        if (this.selectedStudentIds.length != 0) {
            this.activeIndex = 1;
            // Ensure selectedStudentList is populated with current data
            this.selectedStudentList = this.studentList.filter((student) =>
                this.selectedStudents.some(
                    (selected) => selected.id === student.id,
                ),
            );
            this.filterRoomListForTransfer();
        } else {
            this.activeIndex = 0;
        }
    }

    filterRoomListForTransfer() {
        // Get all unique room IDs from both selected arrays
        const allStudents = [
            ...this.selectedStudents,
            ...this.selectedStudentList,
        ];
        const studentRoomIds = new Set<number>();

        allStudents.forEach((student) => {
            // Try multiple ways to get the room ID
            let roomId = null;

            // Method 1: Direct roomId property
            if (student.roomId !== undefined && student.roomId !== null) {
                roomId = student.roomId;
            }
            // Method 2: Nested room object with id
            else if (
                student.room?.id !== undefined &&
                student.room?.id !== null
            ) {
                roomId = student.room.id;
            }

            // Add to set if found
            if (roomId !== null) {
                // Ensure it's a number for consistent comparison
                const numericRoomId =
                    typeof roomId === 'string' ? parseInt(roomId, 10) : roomId;
                studentRoomIds.add(numericRoomId);
            }
        });

        // Filter out classrooms that selected students are currently in
        this.filteredRoomList = this.roomList.filter((room) => {
            if (room.id === undefined || room.id === null) {
                return true; // Keep rooms without valid IDs
            }
            const roomIdNum =
                typeof room.id === 'string' ? parseInt(room.id, 10) : room.id;
            const shouldKeep = !studentRoomIds.has(roomIdNum);

            return shouldKeep;
        });
    }

    prevPage() {
        this.activeIndex = 0;
    }
    handleDateChange(data: any) {}
    buttonDisabled: boolean = false;
    onSave() {
        this.buttonDisabled = true;

        const formatTo12Hour = (time: string): string => {
            if (!time) return ''; // Handle undefined or null cases
            const [hours, minutes] = time.split(':'); // Extract hours and minutes
            let hour = parseInt(hours, 10);
            const ampm = hour >= 12 ? 'PM' : 'AM';
            hour = hour % 12 || 12; // Convert 0/24 to 12
            return `${hour.toString().padStart(2, '0')}:${minutes}:00 ${ampm}`; // Add seconds as 00
        };

        const invalidStudents: string[] = [];
        this.selectedStudents.forEach(
            (student: { studentName: any; id: any; signInTime: any }) => {
                if (
                    this.isSignOutBeforeSignIn(
                        student.signInTime,
                        formatTo12Hour(this.signOutTime),
                    )
                ) {
                    invalidStudents.push(student.studentName);
                }
            },
        );

        if (invalidStudents.length > 0) {
            alert(
                `${invalidStudents.join(', ')}'s Sign-Out Time cannot be same or before Sign-In Time.`,
            );
            this.buttonDisabled = false;
            return;
        }

        // Prepare payload for unified transfer API
        const oldAttendanceIds = this.selectedStudents.map(
            (student) => student.id,
        );
        const transferPayload = {
            oldAttendanceIds: oldAttendanceIds,
            hasStudentId: true,
            staffId: this.userData.refTableId,
            newRoomId: this.selectedRoom,
            transferBy: this.userData.firstName,
            transferTime: formatTo12Hour(this.signOutTime),
            schoolId: this.userData.schoolId,
            date: Common.convertLocalDateToUTC(this.selectedDate),
        };

        this.operationService.transferAttendance(transferPayload).subscribe(
            (res: HttpResponse<any>) => {
                const messages = {
                    severity: 'success',
                    life: 3000,
                    summary: 'Success',
                    detail: `Student transferred successfully.`,
                };
                this.ref.close(messages);
                this.buttonDisabled = false;
            },
            (error) => {
                const messages = {
                    severity: 'error',
                    life: 3000,
                    summary: error.error.summary || 'Error',
                    detail: error.error.title || 'Failed to transfer student',
                };
                this.ref.close(messages);
                this.buttonDisabled = false;
            },
        );
    }
    isSignOutBeforeSignIn(
        signInTime: string | undefined,
        signOutTime: string | undefined,
    ): boolean {
        const format = 'hh:mm:ss A'; // 12-hour format with AM/PM
        const signInMoment = moment(signInTime, format);
        const signOutMoment = moment(signOutTime, format);
        return signOutMoment.isSameOrBefore(signInMoment); // Checks if Sign-Out is same or before Sign-In
    }
    protected subscribeToSaveResponse(
        result: Observable<HttpResponse<any>>,
    ): void {
        result.subscribe(
            () => this.onSaveSuccess(),
            (error: HttpErrorResponse) => this.onSaveError(error),
        );
    }

    protected onSaveSuccess(): void {
        if (this.studentSignIn.value.id == undefined) {
            // this.messageService.add({
            //   severity: 'success',
            //   life: 3000,
            //   summary: 'Success',
            //   detail: `Staff Signed-In successfully.`,
            // });
        } else {
            // this.messageService.add({
            //   severity: 'success',
            //   life: 3000,
            //   summary: 'Success',
            //   detail: `Attendance Updated successfully.`,
            // });
        }
        // this.transferDailog = false;
        // this.isClickedOnce = false;
        // this.selectedStaff = undefined;
        // this.staffSignIn.reset();
        // // this.displayEdit = false;
        // this.displaystaffSignIn = false;
        this.queryData();
        this.ref.close(SignoutStudentComponent);
        // this.loadStaff();
    }

    private onSaveError(error: HttpErrorResponse) {
        // this.isClickedOnce = false;
        const newString = error.error.message?.split('.');
        const timeError = newString ? newString[1] : '';
        const substring = 'Please sign in during school hours';
        if (timeError == 'incorrectTime') {
            this.messageService.add({
                severity: 'warn',
                life: 3000,
                summary: 'Warning',
                detail: substring,
            });
        } else {
            this.messageService.add({
                severity: 'error',
                life: 3000,
      summary: error.error?.title || 'Error',
      detail: error.error?.detail || error.error?.message || error?.message || 'An error occurred'
            });
        }
    }
    queryData() {
        this.search['roomId.notEquals'] =
            this.roomObj.id != undefined ? this.roomObj.id : undefined;
        // this.search.sort = 'fullName,asc';
        this.search['attendedTime.equals'] = '00:00:00';
        if (this.studentSearchInput != undefined) {
            this.search['studentName.contains'] = this.studentSearchInput;
        }
        // if (this.selectedRoomId != undefined) {
        //   this.search['roomId.equals'] = this.selectedRoomId;
        // }
        if (this.selectedTagId != undefined) {
            this.search['tagIds.in'] = this.selectedTagId;
        }
        this.search['status.equals'] = 'A';

        const { startUtc, endUtc } = Common.getUtcDayRange(this.selectedDate);
        this.search['date.greaterThanOrEqual'] = startUtc;
        this.search['date.lessThanOrEqual'] = endUtc;

        this.search['hasSignIn.equals'] = true;
        this.search['studentId.specified'] = true;
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['roomId.in'] = !this.isAdminUserLogin
            ? this.roomIds
            : undefined;
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryAttendance(this.search)
            .subscribe(async (res: HttpResponse<AttendanceDTO[]>) => {
                let temp: AttendanceDTO[] = [];
                this.studentList = res.body ? res.body : temp;
                this.fetchActualStudentList();
                for (const student of this.studentList) {
                    this.selectedStudents = this.studentList.filter((student) =>
                        this.selectedStudentsFromOverview.some(
                            (s) => s.id === student.studentId,
                        ),
                    );
                    this.selectedStudentList = this.selectedStudents;
                    if (student) {
                        if (student.studentPhotoUuid) {
                            this.lookupService
                                .queryDocumentByPhotoUid(
                                    student.studentPhotoUuid,
                                )
                                .subscribe((response: HttpResponse<Blob>) => {
                                    const body = response?.body;
                                    if (body) {
                                        const url =
                                            this.createImgFromBuffer(body);
                                        student.profileimg = url;
                                    }
                                });
                        } else {
                            student.profileimg = undefined;
                        }
                    }
                }

                // If opened from overview/parent with activeIndex=1, filter rooms after data is loaded
                if (
                    this.fromOverView &&
                    this.activeIndex === 1 &&
                    this.selectedStudents.length > 0
                ) {
                    this.filterRoomListForTransfer();
                }
            });
    }

    fetchActualStudentList() {
        let search: any = {};
        search['attendedTime.equals'] = '00:00:00';
        search['status.equals'] = 'A';

        const { startUtc, endUtc } = Common.getUtcDayRange(this.selectedDate);
        search['date.greaterThanOrEqual'] = startUtc;
        search['date.lessThanOrEqual'] = endUtc;

        search['hasSignIn.equals'] = true;
        search['studentId.specified'] = true;
        search['schoolId.equals'] = this.userData.schoolId;
        search['roomId.in'] = !this.isAdminUserLogin ? this.roomIds : undefined;
        Common.removeEmptyFields(search);
        this.lookupService
            .queryAttendance(search)
            .subscribe((res: HttpResponse<any[]>) => {
                let temp: any[] = [];
                this.actualStudList = res.body ? res.body : temp;
            });
    }

    getTagData() {
        this.search = {};
        this.search['status.equals'] = 'A';
        this.search.sort = 'name,asc';
        this.search.size = 500;
        this.search['schoolId.equals'] = this.userData.schoolId;
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryTag(this.search)
            .subscribe((res: HttpResponse<TagDTO[]>) => {
                let temp: TagDTO[] = [];
                this.tagList = res.body ? res.body : temp;
            });
        this.search = {};
    }

    getRoomData(roomId: any) {
        this.search = {};
        this.search['sort'] = 'name,asc';
        this.search['status.equals'] = 'A';
        this.search.size = 500;
        this.search['id.notEquals'] = this.roomObj.id;
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['id.in'] = !this.isAdminUserLogin
            ? this.roomIds
            : undefined;
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryRooms(this.search)
            .subscribe((res: HttpResponse<RoomDTO[]>) => {
                let temp: RoomDTO[] = [];
                this.roomList = res.body ? res.body : temp;
            });
        this.search = {};
    }

    getMasterlookupData() {
        this.lookupService
            .queryMasterLookups({
                size: 10,
                'type.equals': 'Profile Status',
                'value.notEquals': 'I',
                sort: 'id,asc',
            })
            .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                let temp: MasterLookupDTO[] = [];
                this.statusList = res.body ? res.body : temp;
            });
    }

    createImgFromBuffer(blob: Blob) {
        const url = URL.createObjectURL(blob);
        return url;
    }
    onClear() {
        this.search = {};
        this.studentSearchInput = [];
        this.selectedRoomId = undefined;
        this.selectedTagId = [];
        // this.selectedStatus = [];
        // this.selectedStudents = [];
        // this.actualStudList = [];
        // this.selectedStudentIds = [];
        // this.selectAllStudents = false;
        // this.filter();
        // this.filterRoom();
        // this.filterTag();
        // this.filterStatus();
        this.queryData();
    }

    filter() {
        let filtered: StudentDTO[] = [];

        if (this.studentSearchInput.length !== 0) {
            for (let i = 0; i < this.studentList.length; i++) {
                let user = this.studentList[i];
                if (
                    user?.studentName &&
                    (user.studentName
                        .toLowerCase()
                        .indexOf(this.studentSearchInput.toLowerCase()) === 0 ||
                        user.studentName
                            .toLowerCase()
                            .includes(this.studentSearchInput.toLowerCase()))
                ) {
                    filtered.push(user);
                }
            }
        } else {
            filtered = [...this.actualStudList];
        }

        this.studentList = [...filtered];
        this.checkboxChanged();
    }

    filterRoom() {
        let filtered: StudentDTO[] = [];
        this.studentList = [...this.actualStudList];
        if (this.selectedRoomId != undefined) {
            for (let i = 0; i < this.studentList.length; i++) {
                let user = this.studentList[i];
                if (user?.roomId && user.roomId == this.selectedRoomId) {
                    filtered.push(user);
                }
            }
        } else {
            filtered = [...this.actualStudList];
        }
        this.studentList = [...filtered];
        this.checkboxChanged();
    }
    filterTag() {
        let filtered: StudentDTO[] = [];
        if (this.selectedTagId.length === 0) {
            filtered = [...this.actualStudList];
        } else {
            // Create a Set for more efficient lookup
            const selectedTagSet = new Set(this.selectedTagId);

            filtered = this.actualStudList.filter(
                (user) =>
                    user?.tags?.length &&
                    user.tags.some((tag) =>
                        // Check if current tag id matches any selected tag
                        selectedTagSet.has(tag.id),
                    ),
            );
        }

        this.studentList = [...filtered];
        this.checkboxChanged();
    }

    filterStatus() {
        let filtered: StudentDTO[] = [];
        if (this.selectedStatus.length === 0) {
            filtered = [...this.actualStudList];
        } else {
            const selectedStatusSet = new Set(this.selectedStatus);

            filtered = this.actualStudList.filter(
                (user) =>
                    user?.profileStatus &&
                    selectedStatusSet.has(user.profileStatus),
            );
        }

        this.studentList = [...filtered];
        this.checkboxChanged();
    }

    onRemoveStud(event: Event, stud: any) {
        this.confirmationService.confirm({
            key: 'confirm2',
            target: event.target as EventTarget,
            message: `Do you want to Remove ${stud.studentName}?`,
            acceptButtonStyleClass: 'p-button-primary p-button-raised',
            rejectButtonStyleClass: 'p-button-secondary p-button-outlined',
            defaultFocus: 'none',
            accept: () => this.deleteStudents(stud),
            reject: () => {},
        });
    }

    deleteStudents(stud: any) {
        try {
            if (!stud || !stud.id) {
                throw new Error('Invalid student data');
            }

            if (
                !this.selectedStudentList ||
                !this.selectedStudentIds ||
                !this.selectedStudents ||
                !this.studentList
            ) {
                throw new Error('Required arrays are not initialized');
            }

            this.selectedStudentList = this.selectedStudentList.filter(
                (student) => student.id !== stud.id,
            );

            this.selectedStudentIds = this.selectedStudentIds.filter(
                (id) => id !== stud.id,
            );

            this.selectedStudents = this.selectedStudents.filter(
                (student) => student.id !== stud.id,
            );

            const mainListStudent = this.studentList.find(
                (student) => student.id === stud.id,
            );
            if (mainListStudent) {
                mainListStudent.selected = false;
            }

            this.selectAllStudents = false;
            this.submitForm = false;

            this.messageService.add({
                key: 'message',
                severity: 'success',
                life: 3000,
                summary: 'Success',
                detail: 'Student Removed Successfully',
            });
        } catch (error) {
            console.error('Error in deleteStudents:', error);
            this.messageService.add({
                key: 'message',
                severity: 'error',
                life: 3000,
                summary: 'Error',
                detail: (error as Error).message || 'Failed to remove student',
            });
        }
    }

    toggleSelection(student: any) {
        const index = this.selectedStudents.findIndex(
            (selected) => selected.id === student.id,
        );
        if (index !== -1) {
            this.selectedStudents.splice(index, 1);
        } else {
            this.selectedStudents.push(student);
        }
        this.selectedStudentIds = this.selectedStudents.map(
            (selected) => selected.id,
        );

        this.selectedStudentList = this.actualStudList.filter(
            (item: StudentDTO) =>
                this.selectedStudentIds.includes(item.id as number),
        );
    }

    isSelected(student: StudentDTO): boolean {
        return this.selectedStudents.includes(student);
    }

    toggleAllSelection() {
        this.studentList.forEach(
            (student) => (student.selected = this.selectAllStudents),
        );

        if (this.selectAllStudents) {
            this.selectedStudents = [...this.studentList];
        } else {
            this.selectedStudents = [];
        }
        this.selectedStudentIds = this.selectedStudents.map(
            (selected) => selected.id,
        );

        this.selectedStudentList = this.actualStudList.filter(
            (item: StudentDTO) =>
                this.selectedStudentIds.includes(item.id as number),
        );
    }

    checkboxChanged() {
        if (this.studentList && this.studentList?.length !== 0) {
            if (this.isAllSelected()) this.selectAllStudents = true;
            else this.selectAllStudents = false;
        } else {
            this.selectAllStudents = false;
        }
    }

    isAllSelected(): boolean {
        return this.studentList.every((student) => student.selected);
    }

    getInitials(name?: string): string {
        if (!name?.trim()) return '';
        const words = name.trim().split(/[-\s]+/);
        const firstLetter = words[0]?.[0]?.toUpperCase() || '';
        const secondLetter = words[1]?.[0]?.toUpperCase() || '';
        return `${firstLetter}${secondLetter}`.trim();
    }

    getBackgroundColor(id: any) {
        if (!id) return this.profileBgColor[0];
        const index = (id - 1) % this.profileBgColor.length;
        return this.profileBgColor[index];
    }
}
